import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import { HeadingOne } from 'Common/Custom/HeadingOne'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import BookingTable from './Components/BookingTable'

const BookingList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Booking List</HeadingOne>
                    <div className='d-flex gap-2 flex-wrap mt-sm-0 mt-2'>
                        <AddItemBtn url="room-booking" title="Add Booking" />
                    </div>
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <BookingTable />
            </div>
        </PageBody>
    )
}

export default BookingList